import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Input, DatePicker, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { createSession, getAllSessions } from '../../../redux/Session/actions';
import { fetchFreeMachines } from '../../../redux/Machine/actions';
import EditMachineButton from '../Machines/EditMachineButton'; // Import the EditMachineButton component

const { Option } = Select;
const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

export const AddSessionButton = ({ users }) => { // Accept the users prop
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const [selectedMachine, setSelectedMachine] = useState(null); // State for selected machine
  
  const events = useSelector(state => state.events?.data || []);
  const freeMachines = useSelector(state => state.machines?.machines || []);
  const [initialFetched, setInitialFetched] = useState(false); // Prevents multiple fetches

  useEffect(() => {
    if (visible && !initialFetched) {
      dispatch(fetchFreeMachines());
      setInitialFetched(true);
    }
  }, [visible, dispatch, initialFetched]);

  const showModal = () => {
    setVisible(true);
  };

  const hideModal_Ok = () => {
    form.submit();
  };

  const hideModal_Cancel = () => {
    setVisible(false);
    form.resetFields();
    setSelectedMachine(null); // Reset selected machine on cancel
  };

  const form_onFinish = async (values) => {
    const newSession = {
      sessionname: values.sessionname,
      startDate: values.startDate?.toISOString(),
      endDate: values.endDate?.toISOString(),
      event: values.event,
      machine: values.machine,
      isDeleted: false,
    };

    await dispatch(createSession(newSession));
    dispatch(getAllSessions());
    setVisible(false);
    form.resetFields();
    setInitialFetched(false); // Reset fetch status on form submission
  };

  const handleEventChange = (eventId) => {
    const selectedEvent = events.find(event => event._id === eventId);
    if (selectedEvent) {
      form.setFieldsValue({
        startDate: moment(selectedEvent.dateAndTime.startDateTime),
        endDate: moment(selectedEvent.dateAndTime.endDateTime),
      });
    }
  };

  const handleMachineChange = (machineId) => {
    const machine = freeMachines.find(machine => machine._id === machineId);
    setSelectedMachine(machine); // Update selected machine state
  };

  return (
    <>
      <Button type="primary" onClick={showModal}>
        + Créer
      </Button>
      <Modal
        title="Ajouter Session"
        visible={visible}
        onOk={hideModal_Ok}
        onCancel={hideModal_Cancel}
        okText="Valider"
        cancelText="Fermer"
      >
        <Form
          {...layout}
          name="add-session"
          form={form}
          onFinish={form_onFinish}
          initialValues={{ remember: false }}
        >
          <Form.Item
            label="Event"
            name="event"
            rules={[{ required: true, message: 'Please select an event!' }]}
          >
            <Select placeholder="Select an event" onChange={handleEventChange}>
              {events.map((item) => (
                <Option key={item._id} value={item._id}>{item.eventname}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Session Name"
            name="sessionname"
            rules={[
              { required: true, message: 'Please input the session name!' },
              { min: 3, message: 'Session name must be at least 3 characters long' },
              { max: 100, message: 'Session name must be less than 100 characters long' }
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Start Date"
            name="startDate"
            rules={[{ required: true, message: 'Please select a start date!' }]}
          >
            <DatePicker
              format="YYYY-MM-DD HH:mm"
              showTime={{ defaultValue: moment('00:00:00', 'HH:mm') }}
            />
          </Form.Item>

          <Form.Item
            label="End Date"
            name="endDate"
            rules={[{ required: true, message: 'Please select an end date!' }]}
          >
            <DatePicker
              format="YYYY-MM-DD HH:mm"
              showTime={{ defaultValue: moment('00:00:00', 'HH:mm') }}
            />
          </Form.Item>

          <Form.Item
            label="Machine"
            name="machine"
            rules={[{ required: true, message: 'Please select a machine!' }]}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Select
                placeholder="Select a machine"
                onChange={handleMachineChange}
                value={selectedMachine?._id} // Set value to selectedMachine ID
                style={{ flex: 1, marginRight: 8 }} // Ensure the Select takes full width
              >
                {freeMachines.map((item) => (
                  <Option key={item._id} value={item._id}>{item.machinename}</Option>
                ))}
              </Select>
              {selectedMachine && (
                <EditMachineButton item={selectedMachine} users={users} /> // Pass the users prop to EditMachineButton
              )}
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddSessionButton;
